export type SlotsFilters = {
	codeFilter: string;
	teacherFilter: string;
	dayFilter: string;
	durationFilter: string;
	locationFilter: string;
	nonEmptyOnly: boolean;
	availableOnly: boolean;
	startedOnly: boolean;
};

export const EMPTY_FILTERS: SlotsFilters = {
	codeFilter: '',
	teacherFilter: '',
	dayFilter: '',
	durationFilter: '',
	locationFilter: '',
	nonEmptyOnly: false,
	availableOnly: false,
	startedOnly: false,
};
